import React, { useContext, useState, useEffect } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate, useParams } from "react-router-dom";
import {
  createClientIdQueryString,
  sendApiRequest,
} from "../../services/Base/base-service";

import UserContext from "../../store/user-context";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Select,
  Spinner,
  Alert,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
} from "design-react-kit";
import PreviewModal from "./PreviewModal";
import DocumentTypeEnum from "../../helpers/Enums/DocumentTypeEnum";

const ClientDocumentPhrasesConfigModal = ({
  modalOpen,
  modalCloseHandler,
  editablePhrase,
  clientName,
  documentType,
  notifyUser,
  setPhrases,
  setPhrasesNumber,
}) => {
  const [phrase, setPhrase] = useState(null);
  const [keyPhrases, setKeyPhrases] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [approach, setApproach] = useState(null);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const params = useParams();
  const clientId = params?.clientId;
  const clientDocumentRuleId = params?.clientDocumentRuleId;
  const documentTypeId = params?.documentTypeId;

  useEffect(() => {
    if (modalOpen) {
      setError(null);
      setPhrase(null);
      if (editablePhrase === null) {
        sendApiRequest(
          "ClientConfiguration/GetKeyPhrases",
          "GET",
          true,
          { clientId },
          signIn,
          signOut,
          navigate,
          createClientIdQueryString,
          userContext
        ).then((response) => {
          if (response !== undefined) {
            if (response.errors !== null) {
              setError(response.errors);
              setIsLoading(false);
            } else {
              let options = [];
              response.data.keyPhrases.forEach((el) => {
                options.push({
                  value: el.fieldId,
                  label: el.fieldLabel,
                  clientDocumentRuleId: clientDocumentRuleId,
                  notificationTargetFieldId: el.fieldId,
                  beginKeyPhrase: "",
                  endKeyPhrase: "",
                  keyPattern: "",
                  fieldLabel: el.fieldLabel,
                  fieldKeyPhrases: el.fieldKeyPhrases,
                });
              });
              setKeyPhrases(options);
              setIsLoading(false);
              setApproach(
                Number.parseInt(documentTypeId) !== DocumentTypeEnum.F24
                  ? "Key/Value"
                  : "Text"
              );
            }
          }
        });
      } else {
        setPhrase(editablePhrase);
        if (
          editablePhrase.beginKeyPhrase !== "" &&
          editablePhrase.endKeyPhrase === ""
        ) {
          setApproach("Key/Value");
        } else if (
          editablePhrase.beginKeyPhrase !== "" &&
          editablePhrase.endKeyPhrase !== ""
        ) {
          setApproach("Text");
        } else if (
          editablePhrase.beginKeyPhrase === "" &&
          editablePhrase.endKeyPhrase === ""
        ) {
          setApproach("Pattern");
        }
      }
    } else {
      setPhrase(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen, editablePhrase]);

  const changeHandler = (property, value) => {
    setPhrase((curState) => {
      const tempDoc = { ...curState };
      tempDoc[`${property}`] = value;
      return tempDoc;
    });
  };

  const handleSelectedPhraseFieldsChange = (selectedOption) =>
    setPhrase(selectedOption);

  const upsertClientDocumentRuleHandler = () => {
    let data = { ...phrase };
    if (approach === "Key/Value") {
      data.endKeyPhrase = null;
      data.keyPattern = null;
    } else if (approach === "Text") {
      data.keyPattern = null;
    } else if (approach === "Pattern") {
      data.endKeyPhrase = null;
      data.beginKeyPhrase = null;
    }

    sendApiRequest(
      `ClientConfiguration/UpsertClientDocumentFieldConfig`,
      "POST",
      true,
      {
        clientDocumentRuleId: data.clientDocumentRuleId,
        notificationTargetFieldId: data.notificationTargetFieldId,
        beginKeyPhrase:
          data.beginKeyPhrase !== null
            ? data.beginKeyPhrase.trim() === ""
              ? null
              : data.beginKeyPhrase.trim()
            : null,
        endKeyPhrase:
          data.endKeyPhrase !== null
            ? data.endKeyPhrase.trim() === ""
              ? null
              : data.endKeyPhrase.trim()
            : null,
        keyPattern:
          data.keyPattern !== null
            ? data.keyPattern.trim() === ""
              ? null
              : data.keyPattern.trim()
            : null,
      },
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          modalCloseHandler();
          setIsLoading(false);
          notifyUser(
            editablePhrase !== null
              ? "Aggiornamento configurazione per documento (frasi chiave) completato con successo!"
              : "Creazione configurazione per documento (frasi chiave) completata con successo!",
            "success",
            "it-check"
          );
          setTimeout(() => {
            sendApiRequest(
              `ClientConfiguration/GetClientDocumentFieldConfigs?clientDocumentRuleId=${phrase.clientDocumentRuleId}`,
              "GET",
              true,
              null,
              signIn,
              signOut,
              navigate,
              null,
              userContext
            ).then((response) => {
              if (response !== undefined) {
                if (response.errors !== null) {
                  setError(response.errors);
                  setIsLoading(false);
                } else {
                  setPhrases(response.data.clientDocumentFieldConfigs);
                  setIsLoading(false);
                  setTimeout(() => {
                    sendApiRequest(
                      "ClientConfiguration/GetKeyPhrases",
                      "GET",
                      true,
                      { clientId },
                      signIn,
                      signOut,
                      navigate,
                      createClientIdQueryString,
                      userContext
                    ).then((response) => {
                      if (response !== undefined) {
                        if (response.errors !== null) {
                          setError(response.errors);
                          setIsLoading(false);
                        } else {
                          setPhrasesNumber(response.data.keyPhrases.length);
                          setIsLoading(false);
                        }
                      }
                    });
                  }, 500);
                }
              }
            });
          }, 500);
        }
      }
    });
  };

  const constrainInput = (value, eventType) => {
    if (eventType === "insertFromPaste") {
      return value.replace(/[\r\n\v]+/g, " ");
    } else {
      return value.replace(/[\r\n\v]+/g, "");
    }
  };

  const onOptionChangeHandler = (e) => {
    setApproach(e.target.value);
  };

  const enableSaveButtonHandler = () => {
    if (phrase !== null) {
      if (approach === "Key/Value") {
        return phrase.beginKeyPhrase !== null && phrase.beginKeyPhrase !== "";
      } else if (approach === "Text") {
        return (
          phrase.beginKeyPhrase !== null &&
          phrase.beginKeyPhrase !== "" &&
          phrase.endKeyPhrase !== null &&
          phrase.endKeyPhrase !== ""
        );
      } else if (approach === "Pattern") {
        return phrase.keyPattern !== null && phrase.keyPattern !== "";
      }
    }
  };

  return (
    <Modal
      isOpen={modalOpen}
      toggle={modalCloseHandler}
      className="phrasesModal"
      align="center"
      scrollable
      labelledBy="clientDocPhraseConfig"
    >
      <ModalHeader toggle={modalCloseHandler} id="clientDocPhraseConfig">
        <h5
          style={{ fontSize: "28px", textTransform: "capitalize" }}
          className="mb-4"
        >
          {editablePhrase !== null &&
            editablePhrase !== undefined &&
            "Configura Campo"}{" "}
          {(editablePhrase === null || editablePhrase === undefined) &&
            "Aggiungi Campo"}{" "}
        </h5>
        {clientName !== null && clientName !== undefined && (
          <p>
            Tipologia servizio:{" "}
            <span style={{ color: "#0073e6" }}>{clientName}</span>
          </p>
        )}
        {documentType !== null && documentType !== undefined && (
          <div className="mb-3">
            Documento: <span style={{ color: "#0073e6" }}>{documentType}</span>
          </div>
        )}
        {editablePhrase !== null &&
          editablePhrase !== undefined &&
          phrase !== null &&
          phrase !== undefined &&
          (phrase.notificationTargetFieldLabel !== undefined ||
            phrase.notificationTargetFieldLabel !== null ||
            phrase.fieldLabel !== undefined ||
            phrase.fieldLabel !== null) && (
            <div>
              Campo:{" "}
              <span style={{ color: "#0073e6" }}>
                {phrase?.notificationTargetFieldLabel || phrase?.fieldLabel}
              </span>
            </div>
          )}
      </ModalHeader>
      <ModalBody className="col-12">
        {isLoading && <Spinner double active />}
        {!isLoading && error !== null && error.length !== undefined && (
          <Alert color="danger">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {(editablePhrase === null || editablePhrase === undefined) && (
          <div className="bootstrap-select-wrapper mt-5">
            <label htmlFor="phrases">Seleziona Campo:</label>
            <Select
              id="phrases"
              className="mb-5"
              isSearchable={true}
              onChange={handleSelectedPhraseFieldsChange}
              options={keyPhrases}
              value={phrase}
              placeholder="-Seleziona-"
              aria-label="Seleziona"
            />
          </div>
        )}
        {((editablePhrase !== null && editablePhrase !== undefined) ||
          phrase !== null) && (
          <>
            <Col>
              <div>Modalità di analisi:</div>
              <Form className="d-flex">
                {Number.parseInt(documentTypeId) !== DocumentTypeEnum.F24 && (
                  <FormGroup check className="form-check-group">
                    <Input
                      id="key-value"
                      name="analysisApproach"
                      type="radio"
                      value="Key/Value"
                      checked={approach === "Key/Value"}
                      onChange={(e) => onOptionChangeHandler(e)}
                    />
                    <Label
                      className="ml-4 text-nowrap pr-4"
                      htmlFor="key-value"
                      check
                    >
                      Chiave / Valore
                    </Label>
                  </FormGroup>
                )}
                <FormGroup check className="form-check-group">
                  <Input
                    id="text"
                    name="analysisApproach"
                    type="radio"
                    value="Text"
                    checked={approach === "Text"}
                    onChange={(e) => onOptionChangeHandler(e)}
                  />
                  <Label className="ml-4 pr-4" htmlFor="text" check>
                    Testuale
                  </Label>
                </FormGroup>
                {Number.parseInt(documentTypeId) !== DocumentTypeEnum.F24 && (
                  <FormGroup check className="form-check-group">
                    <Input
                      id="pattern"
                      name="analysisApproach"
                      type="radio"
                      value="Pattern"
                      checked={approach === "Pattern"}
                      onChange={(e) => onOptionChangeHandler(e)}
                    />
                    <Label className="ml-4 pr-0" htmlFor="pattern" check>
                      Combinata
                    </Label>
                  </FormGroup>
                )}
              </Form>
            </Col>
            {(approach === "Key/Value" || approach === "Text") && (
              <div className="mb-3">
                <label htmlFor={`${phrase?.clientDocumentRuleId}-start`}>
                  {approach === "Key/Value" && "Chiave identificativa"}
                  {approach === "Text" &&
                    "Frase identificativa/soglia iniziale"}
                </label>
                <textarea
                  id={`${phrase?.clientDocumentRuleId}-start`}
                  placeholder={phrase?.fieldKeyPhrases}
                  value={phrase?.beginKeyPhrase}
                  rows={3}
                  onChange={(e) => {
                    const eventType = e.nativeEvent.inputType;
                    const value = constrainInput(e.target.value, eventType);
                    changeHandler("beginKeyPhrase", value);
                  }}
                ></textarea>
              </div>
            )}
            {approach === "Text" && (
              <div className="mb-3">
                <label htmlFor={`${phrase?.clientDocumentRuleId}-end`}>
                  {"Frase soglia finale"}
                </label>
                <textarea
                  id={`${phrase?.clientDocumentRuleId}-end`}
                  value={phrase?.endKeyPhrase}
                  rows={3}
                  onChange={(e) => {
                    const eventType = e.nativeEvent.inputType;
                    const value = constrainInput(e.target.value, eventType);
                    changeHandler("endKeyPhrase", value);
                  }}
                ></textarea>
              </div>
            )}
            {approach === "Pattern" &&
              Number.parseInt(documentTypeId) !== DocumentTypeEnum.F24 && (
                <div className="mb-3">
                  <label htmlFor={`${phrase?.clientDocumentRuleId}-keyPattern`}>
                    <div>Regola di composizione del valore campo</div>
                    <div>
                      E' possibile combinare uno o più valori estratti
                      dinamicamente dalle chiavi disponibili (referenziate come
                      placeholders racchiusi tra '**')
                    </div>
                  </label>
                  <textarea
                    id={`${phrase?.clientDocumentRuleId}-keyPattern`}
                    value={phrase?.keyPattern}
                    placeholder="**Indirizzo**, **Civico** **CAP** **Città** (**Provincia**)"
                    rows={3}
                    onChange={(e) => {
                      const eventType = e.nativeEvent.inputType;
                      const value = constrainInput(e.target.value, eventType);
                      changeHandler("keyPattern", value);
                    }}
                  ></textarea>
                </div>
              )}
            {approach !== null && (
              <div className="col-sm-12 mb-2 d-flex align-items-center justify-content-around">
                <PreviewModal />
                <Button
                  color="white"
                  className="mr-2"
                  onClick={modalCloseHandler}
                  id="user-cancel"
                >
                  Annulla
                </Button>
                <Button
                  style={{
                    backgroundColor: "#5EB423",
                    color: "#fff",
                    padding: "7px 15px",
                  }}
                  disabled={!enableSaveButtonHandler()}
                  onClick={(e) => upsertClientDocumentRuleHandler()}
                >
                  Salva
                </Button>
              </div>
            )}
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ClientDocumentPhrasesConfigModal;
